import { AppCategory } from '../types';
import { getCategoryDisplayName } from '../utils/categoryMapping';

interface CategoryFilterProps {
  categories: (AppCategory | 'All')[];
  selected: AppCategory | 'All';
  onChange: (category: AppCategory | 'All') => void;
}

export default function CategoryFilter({ categories, selected, onChange }: CategoryFilterProps) {
  const getDisplayName = (category: AppCategory | 'All'): string => {
    if (category === 'All') return 'All';
    return getCategoryDisplayName(category);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onChange(category)}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
            selected === category
              ? 'bg-recipe-accent text-recipe-bg'
              : 'bg-recipe-card text-recipe-text-muted border border-recipe-border hover:border-recipe-accent hover:text-recipe-text'
          }`}
        >
          {getDisplayName(category)}
        </button>
      ))}
    </div>
  );
}
